import { deleteWorkspaceByIdAndReloadClientData } from '@modules/settings/workspace/stores/workspace.thunks'
import { useUserStore } from '@modules/user/stores/user.store'
import { useWorkspacesStore } from '@modules/workspaces/stores/workspaces.store'
import { leaveWorkspaceMembershipAndReloadClientData } from '@modules/workspaces/stores/workspaces-membership-reload.thunks'

import type { Organization } from '../../settings.interface'
import { getCurrentUserMembershipUserId } from '../../utils/isCurrentWorkspaceMember'
import { mapWorkspaceToOrganization } from '../mappers/mapWorkspaceToOrganization'

function mapWorkspacesToOrganizations(): Organization[] {
  return useWorkspacesStore.getState().workspaces.map(mapWorkspaceToOrganization)
}

export async function leaveOrganizationAndReloadClientData(organizationId: string): Promise<Organization[]> {
  const membershipUserId = getCurrentUserMembershipUserId(useUserStore.getState().currentUser)
  if (!membershipUserId) {
    throw new Error('Failed to leave organization')
  }

  await leaveWorkspaceMembershipAndReloadClientData(organizationId, membershipUserId)

  return mapWorkspacesToOrganizations()
}

export async function deleteOrganizationAndReloadClientData(organizationId: string): Promise<Organization[]> {
  await deleteWorkspaceByIdAndReloadClientData(organizationId)
  return mapWorkspacesToOrganizations()
}
